import { Box, useMediaQuery } from '@mui/material';
import React from 'react';

function CkEeditorfields({ name, icon, width, isIcon, isDisable, title }) {
  const isMobile = useMediaQuery('(max-width:768px)');
  return (
    <>
      <Box
        pr={0}
        pl={0.5}
        py={isMobile ? 1.2 : 1.6}
        display={'flex'}
        alignItems={'center'}
        title={title}
        columnGap={2}
        sx={{
          background: isDisable ? '#D9D9D9' : '#ECF0E5',
          borderRadius: '6px',
          width: width || '50%',
          cursor: isDisable ? 'not-allowed' : 'pointer',
          border: '1px solid transparent',
          transition: 'all 0.5s cubic-bezier(0.19, 1, 0.22, 1)',
          '&:hover': {
            backgroundColor: 'transparent',
            border: '1px solid #B7D423'
          }
        }}
      >
        {isIcon ? icon : <img width={30} height={30} src={icon} alt='err' />}
        <div className={isMobile ? 'medium6' : 'medium4'}>{name}</div>
      </Box>
    </>
  );
}

export default CkEeditorfields;
